import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { HodAddComments, HodSpecificSavedReport, AdminSpecificSavedReport, DirectorSpecificSavedReport } from "../../Repository/Api";
import AppraisalReportSpecificView from "../Common/AppraisalReportSpecificView";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";
const HodReportSpecificView = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation()
  const isHod = pathname.includes('Hod')
  const isAdmin = pathname.includes('admin')
  const isDirector = pathname.includes('Director')
  useEffect(() => {
    getSpecificSavedReportlist();
  },[]);

  const [openModal, setOpenModal] = useState(false)
  const [report, setReport] = useState({});
  
  const [comments, setComments] = useState({
    hod_comment: "Recommended",
    hod_declaration: false
  })
  
  const [active, setActive] = useState(0);
  const links = ["Part - A", "Part - B", "Part - C", "Part - D", "Part - E"];
  const showSelected = (index) => {
    setActive(index);
  };

  const getSpecificSavedReportlist = async () => {
    let response
    response = isHod ? await HodSpecificSavedReport(id, token)
      : isAdmin ? await AdminSpecificSavedReport(id, token)
        : isDirector && await DirectorSpecificSavedReport(id, token)
    if (response && response.statusCode === 200) {
      setReport(response.data);
    } else {
      errorMsg(response.message);
    }
  };
  const handleCommentChange = (e, key) => {
    setComments({
      ...comments,
      [key]: e.target.value
    })
  }

  const handleCommentSubmit = async () => {
    const Payload = {
      ...comments,
      id: id
    }
    if (comments?.hod_declaration) {
      const response = await HodAddComments(Payload, token)
      if (response && response.statusCode === 200) {
        setOpenModal(false)
        successMsg(response.message)
        navigate(-1)
      } else {
        setOpenModal(false)
        errorMsg(response?.message)
      }
    } else {
      setOpenModal(false)
      errorMsg('Please accept the terms')
    }
  }
  
  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-3 my-auto">
                    <h6 className="labeltitle">
                      <span
                        className="arrowicon"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        ← &nbsp;
                      </span>
                      Appraisal Report
                    </h6>
                  </div>
                  <div className="col-lg-3 my-auto">
                    <div>
                      <label className="labeltext">Select a Year</label>
                      <input
                        type="text"
                        className="fieldinput"
                        defaultValue={report?.academic_year}
                        disabled
                      />
                    </div>
                  </div>

                  {report?.month ? (
                    <div className="col-lg-3 my-auto">
                      <div>
                        <label className="labeltext">Select Month</label>
                        <input
                          type="text"
                          className="fieldinputselect"
                          defaultValue={report?.month}
                          disabled
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mt-5">
                  <ul className="searchtopflex">
                    {links.map((link, index) => {
                      return (
                        <li
                          onClick={() => showSelected(index)}
                          key={link}
                          className={
                            active === index
                              ? "agenttextactive"
                              : "agenttextinactive"
                          }
                        >
                          {link}
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <AppraisalReportSpecificView
                  report={report}
                  active={active}
                  handleCommentChange={handleCommentChange}
                  setComments={setComments}
                  setOpenModal={setOpenModal}
                  isHod={isHod}
                  comments={comments}
                  isEmployee={false}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <CustomModal
        open={openModal}
        onClickOutside={() => {
          setOpenModal(false);
        }}
      >
        <div className="modal-content Modal-View m-auto">
          <div className="modal-body p-0 ">
            <div className="container">
              <div className="comingsoon">
                <h4>Are you sure you want to submit?</h4>
              </div>
            </div>
          </div>
          <div className="modal-footer border-0">
            <div>
              <button
                className="requestbtn"
                onClick={handleCommentSubmit}
              >
                Submit
              </button>
              <button
                type="button"
                className="close-btn"
                onClick={() => {
                  setOpenModal(false);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default HodReportSpecificView;